<template>
  <v-container fluid>
    <component :is="currentView" :metrics="metrics" :reviewData="reviewData" :accountsData="accountsData" />
  </v-container>
</template>

<script>
import AdminDashboard from './blocks/boards/admin_dashboard.vue';
import OperationsDashboard from './blocks/boards/operations_dashboard.vue';
import AccountsDashboard from './blocks/boards/accounts_dashboard.vue';
import ManagerDashboard from './blocks/boards/manager_dashboard.vue';

export default {
  name: 'Dashboard',
  components: {
    AdminDashboard,
    OperationsDashboard,
    AccountsDashboard,
    ManagerDashboard
  },
  data() {
    return {
      currentView: null,
      metrics: [],
      reviewData: [],
      accountsData: []
    }
  },
  mounted() {
    // this.currentView = `${this.$store.state.auth.profile.role.toLowerCase()}-dashboard`;
    this.currentView = 'admin-dashboard';
    this.$api.dashboard.getOperationsMetrics().then((response) => {
      this.metrics = response.metrics;
      this.reviewData = response.review_metrics;
      this.accountsData = response.accounts_metrics;
    });
  },
}
</script>